<template>
  <div class="tradeActivityList">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-button @click="changeInfo()" type="primary" size="small">设置推荐奖励方案</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
        <el-table-column :label="$t('common.handle')" width="240">
          <template slot-scope="scope">
            <el-button size="mini" type="danger">{{$t('common.detail')}}</el-button>
            <el-button @click="changeInfo(scope.row)" size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button size="mini" type="primary">{{$t('common.delete')}}</el-button>
            <el-button size="mini" type="danger">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentTradeActivityList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="推荐奖励设置" :visible.sync="isReferralRewardPop">
      <el-form label-width="280px">
        <el-form-item label="方案名称">
          <el-input v-model="referralRewardForm.planName"></el-input>
        </el-form-item>
        <el-form-item label="支持平台">
          <el-checkbox v-model="referralRewardForm.platform">TRADE</el-checkbox>
        </el-form-item>
        <el-form-item label="直接推荐人交易奖励比例 ">
          <el-input v-model="referralRewardForm.directAmount"></el-input>
        </el-form-item>
        <el-form-item label="间接推荐人交易奖励比例 ">
          <el-input v-model="referralRewardForm.indirectAmount"></el-input>
        </el-form-item>
      </el-form>
      <div class="flexCenter">
        <el-button type="primary">{{$t('common.ok')}}</el-button>
        <el-button @click="isReferralRewardPop=false">{{$t('common.cancle')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'
  export default {
    name: 'tradeActivityList',
    data() {
      return {
        tableNav: [
          { name: '方案名称', id: 'planName' },
          { name: '创建时间', id: 'createTime' },
          { name: '创建人', id: 'operator' },
          { name: '状态', id: 'activeStatuss' }
        ],
        tableData: [],
        isReferralRewardPop: false,
        referralRewardForm: {
          planName: '',
          platform: '',
          directAmount: '',
          indirectAmount: ''
        },
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getTradeActivityListData(data) {
        nationalMarketing.queryRecommendPlanListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].createTime)) {
                  data[i].createTime = new Date(data[i].createTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].activeStatus)) {
                  if (data[i].activeStatus == 0) data[i].activeStatuss = '待审批'
                  if (data[i].activeStatus == 1) data[i].activeStatuss = '审批通过'
                  if (data[i].activeStatus == 2) data[i].activeStatuss = '审批不通过'
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initTradeActivityListData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getTradeActivityListData(data)
      },
      changeCurrentTradeActivityList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getTradeActivityListData(data)
      },
      changeInfo(obj) {
        this.isReferralRewardPop = !this.isReferralRewardPop
      }
    },
    mounted() {
      this.initTradeActivityListData()
    }
  }
</script>

<style lang="scss" scoped>
  .tradeActivityList {
    margin: 20px;

    .flexCenter {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
